import { Api } from 'models/services/api';
import { ReadRelationshipsByMenuCategoryIdQuery } from 'models/services/graphql';

import { RelationshipCollectionData } from '../collection';

type DataToFetch = {
  menuCategoryId: string;
  limit?: number;
  nextToken?: string;
};

const RequestQuery = `
  query ReadRelationshipsByMenuCategoryId($menuCategoryId: ID!, $limit: Int, $nextToken: String) {
    ${ReadRelationshipsByMenuCategoryIdQuery}
  }
`;

type ResponseData = {
  data: {
    readRelationshipsByMenuCategoryId: RelationshipCollectionData;
  }
}

class ReadCollectionByMenuCategoryIdGql {

  readonly result?: RelationshipCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readRelationshipsByMenuCategoryId;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionByMenuCategoryIdGql };
